<div class="max-w-4xl mx-auto px-6 py-16">
  <div class="text-center">
    <img class="mx-auto" src="img/404_art.jpg" alt="404" style="width: 100%; max-width: 550px;">
    <div class="mt-6">
      <h3 class="text-3xl font-serif text-gold mb-4">Page Not Found</h3>
      <p class="text-gray-600 mb-4">It seems we can’t find the page you are looking for.<br>
        <a routerLink="/" class="text-gold hover:text-gold-dark underline transition duration-300">Go back to Homepage</a><br>
        Or try using search at the top right corner of the page.</p>
    </div>
  </div>
</div>
